/* The module specifier is the cache key: three callers importing this with
   three different ?v= values meant three separate downloads of the same 27KB
   file. Every importer now uses the same string. */
import {generateProductHtml} from "./ob-generate-product-html.js?v=14233445440"


// Wait for the document to fully load before running the script
document.addEventListener('DOMContentLoaded', function() {
const countryIso = document.body.getAttribute("country-iso");
const is_sale = document.body.dataset.sale == "true";
  

  let globRedirect = "";

  document.querySelectorAll('.search-collapse-input').forEach(input => {
  input.addEventListener('keydown', function(event) {
    if (event.key === 'Enter') {
      if(globRedirect){
       event.preventDefault(); 
      window.location.href = globRedirect;
      }
    }
  });
});
const market = document.body.getAttribute("market") === 'gb' ? 'uk' : document.body.getAttribute("market");
  const marketTag = `country-${market}`;
  const equivelant100 = parseFloat(document.getElementById("100-money").value);
  const currencySymbol = document.body.getAttribute("currency-symbol")
  
    const countryUrl = document.body.getAttribute("country-url");
    let searchTranslations = {
    "default": {
        "try": "try",
        "see_more": "see more",
        "quick_buy": "quick buy",
        "add_another": "add another",
        "search_for_products": "search for products"
      },
    "nl": {
          "try": "proberen",
          "see_more": "meer bekijken",
          "quick_buy": "snel kopen",
          "add_another": "nog een toevoegen",
          "search_for_products": "Zoeken naar producten"
      },
      "de": {
        "see_more": "Meer zien",
        "quick_buy": "Snel kopen",
        "add_another": "Voeg een andere toe"
      },
      "en": {
        "see_more": "see more",
        "quick_buy": "quick buy",
        "add_another": "add another"
      }
    }
  const debug = {
    enabled: true,
    log: function(...args) {
        if (this.enabled) {
            console.log(...args);
        }
    },
    error: function(...args) {
        if (this.enabled) {
            console.error(...args);
        }
    }
};
let searchLanguage = document.body.getAttribute("language");
  
  let labelList;

  // Containers the search dropdown renders cards into. Labels and price
  // updates are scoped to these so they never touch the collection grid.
  const SEARCH_CARD_ROOTS = '#search-rsults, #pre-search-product-suggestions';

  const LAUNCH_OFFER_ICON = `<svg height="20px" width="20px" style="stroke: white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="#fff" x="0px" y="0px"><path d="M4.03196 18.98H6.77929C7.71819 16.6885 8.86513 14.4879 10.2057 12.4058C10.8009 11.5816 11.3945 10.8033 11.9864 10.0709C10.6318 10.189 9.31106 10.5582 8.09154 11.1595C6.85362 11.8141 5.8199 12.797 5.10379 14.0003C4.38768 15.2037 4.01684 16.5811 4.03196 17.9814V18.98Z" fill="black"/><path d="M13.02 25.2207C15.3116 24.2802 17.5123 23.1316 19.5942 21.7893C20.4218 21.1947 21.2001 20.6029 21.9291 20.0137C21.811 21.3682 21.4418 22.6889 20.8405 23.9085C20.1859 25.1464 19.203 26.1801 17.9997 26.8962C16.7963 27.6123 15.4189 27.9832 14.0186 27.968H13.02V25.2207Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28 7C27.8613 11.3428 24.7311 15.65 18.4308 20.1694C16.7146 21.282 14.904 22.2417 13.02 23.0376V22.4754C13.0155 21.5497 12.6458 20.6633 11.9913 20.0087C11.3367 19.3542 10.4503 18.9845 9.52463 18.98H8.96238C9.75922 17.096 10.7203 15.2858 11.8346 13.5702C16.3475 7.27364 20.6518 4.14381 24.992 4C24.9947 4 24.9973 4 25 4H28V7ZM21.2767 10.7233C21.7449 11.1915 22.008 11.8265 22.008 12.4887C22.008 13.1508 21.7449 13.7859 21.2767 14.2541C20.8085 14.7223 20.1735 14.9854 19.5113 14.9854C18.8492 14.9854 18.2141 14.7223 17.7459 14.2541C17.2777 13.7859 17.0146 13.1508 17.0146 12.4887C17.0146 11.8265 17.2777 11.1915 17.7459 10.7233C18.2141 10.2551 18.8492 9.99201 19.5113 9.99201C20.1735 9.99201 20.8085 10.2551 21.2767 10.7233Z" fill="black"/><path d="M10.1458 26.0915C9.24001 26.9963 6.52863 27.5536 5.40413 27.7533L4 28L4.24667 26.5959C4.44541 25.4714 5.00366 22.76 5.90846 21.8542C6.47036 21.2923 7.23247 20.9766 8.02713 20.9766C8.42061 20.9766 8.81023 21.0541 9.17375 21.2047C9.53727 21.3553 9.86758 21.576 10.1458 21.8542C10.424 22.1324 10.6447 22.4627 10.7953 22.8263C10.9459 23.1898 11.0234 23.5794 11.0234 23.9729C11.0234 24.3663 10.9459 24.756 10.7953 25.1195C10.6447 25.483 10.424 25.8133 10.1458 26.0915Z" fill="black"/></svg>`;

async function get_designs() {
    // Pull print information from metaobjects, store in above array
    const design_url = 'https://www.myoddballs.com/pages/gift-ideas-for-all-occasions?view=get-designs';
    try {
        const response = await fetch(design_url);
        const data = await response.text();
        glob_designs = JSON.parse(data).designs
    } catch (error) {
        console.error('Error fetching designs:', error);
    }
}

async function get_labels() {
  const countryUrl = document.body.getAttribute("country-url");
  const url = countryUrl ? `https://www.myoddballs.com${countryUrl}/pages/perfect-pair?view=labels` : "https://www.myoddballs.com/pages/perfect-pair?view=labels";
  
  const data12 = await fetch(url);
  const html = await data12.text();

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
let tempLabels = []
  const inputs = doc.querySelectorAll("input.tag");
  inputs.forEach(input => {
    tempLabels.push(JSON.parse(input.value));
  });
  labelList = tempLabels;
}
	function waitForNostoJs(callback) {
		var checkInterval = setInterval(function() {
		if (typeof window.Nosto !== 'undefined') {
			clearInterval(checkInterval);
			callback();
		}
		}, 100); // Check every 100 milliseconds
	}
		
(async () => {
    waitForNostoJs(async function() {
        console.log('nostojs is ready');
        initNostoDependentFunctions();
        await Promise.all([get_labels()]);
    });
})();
let prodsAddedFlag = false;

// Same behaviour as the collection file's addLabels, but scoped to the
// search containers (or a single root) instead of every .product-card on the page.
function addLabels(root = null, count = 0) {
    if (count >= 20) return;

    if (!(prodsAddedFlag && labelList)) {
        setTimeout(function() {
            addLabels(root, count + 1);
        }, 300);
        return;
    }

    const scopes = root ? [root] : Array.from(document.querySelectorAll(SEARCH_CARD_ROOTS));

    scopes.forEach(function(scope) {
        scope.querySelectorAll('.product-card').forEach(function(card) {
            try {
                if (card.classList.contains("nosto_element")) {
                    return;
                }
                const prodInfo = card.querySelector('.prod-info');
                if (!prodInfo) return;
                const prod = JSON.parse(prodInfo.value);
                let label = generateProductLabel(prod);

                if (card.classList.contains("flash-sale-product")) {
                    const progBar = card.querySelector(".sale-progress-bar");
                    const funkyBg = progBar?.style.background;
                    label = `<span class="flash-sale-label flex items-center absolute top-2 right-2 rounded font-display text-3xs lg:!text-md  font-bold uppercase rounded-md" style="z-index:12;
                     background: ${progBar? funkyBg : "#f00"};
                      color:#fff; border: 2px solid #F00${progBar && "0"}; box-shadow: 1px 1px 1px rgb(0 0 0 / 30%);">
                    <div style="background:black; padding: 0.25rem; border-radius: 0.305rem; display: flex; align-items: center;">
${LAUNCH_OFFER_ICON}                    Launch Offer
                    </div>
                    </span>
`
                }

                const labelLoc = card.querySelector('.label-loc');
                if (!labelLoc) return;
                labelLoc.innerHTML = label || "";
            } catch (error) {
                console.error("Error adding label: " + error);
            }
        });
    });
}

// Ported from the collection file so both grids pick the same label.
function generateProductLabel(data) {
    if (!Array.isArray(labelList)) return null;

    const tags = data.tags1;
    if (!Array.isArray(tags)) return null;

    // compare in integer pence/cents — Math.round, not floor:
    // 4.35 * 100 === 434.99999999999994, so floor() would drop a penny
    const toPence = (value) => Math.round(Number(value) * 100);
    const prod_pence = toPence(data.price);
    const comp_pence = toPence(data.listPrice);
    const marketIso = document.body.getAttribute("market");

    const render = (label, text) =>
        `<span class="${label.show_hide_class} top-2 right-2 rounded px-1.5 py-1 font-display text-3xs lg:!text-md font-bold uppercase rounded-md" style="z-index:12; background-color: ${label.bg_color}; color:${label.text_color}; border: 2px solid ${label.outline_color}; box-shadow: 1px 1px 1px rgb(0 0 0 / 30%);">${text}</span>`;

    for (const label of labelList) {
        if (!label || label.theme_version !== "B") continue;

        const labelMatch = label.tag_match;
        if (!tags.includes(labelMatch)) continue;

        if (labelMatch === "label-launch-offer") {
            return `<span class="flash-sale-label flex items-center absolute top-2 right-2 rounded font-display text-3xs lg:!text-md  font-bold uppercase rounded-md" style="z-index: 12; background: linear-gradient(rgb(255, 255, 255), rgb(255, 255, 255)) padding-box padding-box, linear-gradient(to right, rgb(186, 8, 81) 0%, rgb(244, 20, 153) 33%, rgb(249, 120, 203) 66%, rgb(244, 20, 153) 100%); color: rgb(255, 255, 255); box-shadow: rgba(0, 0, 0, 0.3) 1px 1px 1px; border: 2px solid transparent;">
                    <div style="background:black; padding: 0.25rem; border-radius: 0.305rem; display: flex; align-items: center;">
${LAUNCH_OFFER_ICON}                    Launch Offer
                    </div>
                    </span>`;
        }

        if (labelMatch === "label-sale-percent-discount") {
            if (comp_pence > prod_pence) {
                const savings = Math.round(((comp_pence - prod_pence) / comp_pence) * 100);
                if (savings < 1) {
                    debug.log("[label] suppressed sub-1% discount", data.name, { price: data.price, listPrice: data.listPrice });
                    continue;
                }
                return render(label, `${savings}${translations.collections.percent_saving}`);
            }
            continue;
        }

        if (labelMatch === "label-sale-value-discount") {
            if (comp_pence > prod_pence) {
                const diff = comp_pence - prod_pence;
                // whole units stay as "5", anything else formats to "4.50"
                const savings = diff % 100 === 0 ? String(diff / 100) : (diff / 100).toFixed(2);
                if (marketIso == "se" && data.name?.toLowerCase().includes("bundle")) {
                    return render(label, "Köp fler – spara mer");
                }
                return render(label, `Save ${GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, savings)}`);
            }
            continue;
        }

        return render(label, label.text);
    }

    return null;
}

// Collection-file order: update non-UK prices first, wait for all of them,
// then generate labels from the updated prod-info.
async function finaliseSearchCards(products, container) {
    if (!container) return;

    if (market !== 'uk' && Array.isArray(products)) {
        await Promise.all(products.map(product => updateNonUKPrices(product.productId, container)));
    }

    container.querySelectorAll(".price-loading").forEach((el) => {
        el.classList.remove("price-loading");
    });

    addLabels(container);
}

	// Function to add a character to the placeholder with a random delay to simulate typing
	function addToPlaceholder(toAdd, el) {
		// Append the new character to the current placeholder text
		el.placeholder = el.placeholder + toAdd;
		// Return a promise that resolves after a random delay between 50 and 100 milliseconds
		return new Promise(resolve => setTimeout(resolve, 50 + Math.random() * 50));
	}

	// Function to remove the last character from the placeholder with a random delay to simulate backspacing
	function removeFromPlaceholder(el) {
		let currentPlaceholder = el.placeholder;
		if (currentPlaceholder.length > 0) {
			// Remove the last character from the placeholder text
			el.placeholder = currentPlaceholder.slice(0, -1);
			// Return a promise that resolves after a random delay between 25 and 50 milliseconds
			return new Promise(resolve => setTimeout(resolve, 25 + Math.random() * 25));
		}
		// If there's no text left, resolve the promise immediately
		return Promise.resolve();
	}
	
	// Function to clear the placeholder text down to a certain number of characters
	function clearPlaceholder(el, charsToKeep = 0) {
		return new Promise(resolve => {
			// Recursive function to remove characters one by one
			function clear() {
				if (el.placeholder.length > charsToKeep) {
					// Remove one character and call clear() again
					removeFromPlaceholder(el).then(clear);
				} else {
					// When desired length is reached, resolve the promise
					resolve();
				}
			}
			clear();
		});
	}
	
	// Function to type out a phrase in the placeholder
	function printPhrase(phrase, el) {
		return new Promise(resolve => {
			let letters = phrase.split('');
			// Chain promises to type each letter sequentially
			letters.reduce(
				(promise, letter, index) => promise.then(() => {
					// When the last letter is typed, wait for 1 second before resolving
					if (index === letters.length - 1) {
						setTimeout(resolve, 1000);
					}
					// Add the next letter to the placeholder
					return addToPlaceholder(letter, el);
				}),
				Promise.resolve()
			);
		});
	}
	
	// Function to cycle through an array of terms, animating each one in the placeholder
	function suggestTerms(basePhrase, terms, el) {
		return terms.reduce((promise, term, index) => {
			let phrase;
			if (index === 0) {
				// For the first term, prepend the base phrase
				phrase = `${basePhrase}"${term}"`;
			} else if (index === terms.length - 1) {
				// For the last term, change the phrase
				phrase = `${translations.search.or_maybe} "${term}"`;
			} else {
				// For other terms, just display the term in quotes
				phrase = `"${term}"`;
			}

			return promise
				.then(() => {
					// Type out the phrase in the placeholder
					return printPhrase(phrase, el);
				})
				// Wait for a short pause before clearing the placeholder
				.then(() => new Promise(resolve => setTimeout(resolve, 300)))
				.then(() => {
					// Clear the placeholder, keeping the base phrase if necessary
					if (index < terms.length - 2) {
						return clearPlaceholder(el, basePhrase.length);
					} else {
						return clearPlaceholder(el);
					}
				});
		}, Promise.resolve());
	}
	
	// Function to manage the animation loop for the placeholder text
	function animatePlaceholder(el, loopCount = 0) {
		// Define basePhrase here
		let basePhrase = translations.search.try;
		// Define terms here as well
		let terms = Object.values(translations.search.search_terms);
	
		printPhrase(translations.search.search_for_products, el)
			// Wait for a short pause after typing the initial phrase
			.then(() => new Promise(resolve => setTimeout(resolve, 300)))
			// Clear the placeholder text
			.then(() => clearPlaceholder(el))
			// Start suggesting terms
			.then(() => suggestTerms(basePhrase, terms, el))
			// Wait for a short pause after suggestions
			.then(() => new Promise(resolve => setTimeout(resolve, 300)))
			.then(() => {
				// Loop the animation if the loop count hasn't been reached
				if (loopCount < 1) {
					animatePlaceholder(el, loopCount + 1);
				} else {
					// After looping, type out the default placeholder text
					printPhrase(translations.search.search_for_products, el);
				}
			});
	}
	
	// Function to initialize and run the animated placeholder
    function runAnimatedPlaceholder() {
        // Base phrase to prepend to suggestions
        let basePhrase = translations.search.try;
        // Array of terms to suggest
        let terms = Object.values(translations.search.search_terms); 
    
        // Get all search input elements with the specified class
        const searchInputs = document.querySelectorAll('.search-collapse-input');
        
        // Start the animation on each search input
        searchInputs.forEach(input => {
            if (input) {
                animatePlaceholder(input);
            }
        });
    }
	
	// Run the animated placeholder when the document is ready
	runAnimatedPlaceholder();
	  
	function initNostoDependentFunctions() {
		const searchInputs = document.querySelectorAll('.search-collapse-input');
	
		searchInputs.forEach(input => {
		  const debouncedSearch = debounce(function() {
			if (input.value.length > 2 && !input.value.includes("/")) {
			  performSearch(input.value);
                      showLoadingIndicator(input);
			} else {
			  //showSearchSuggestions();
			}
		  }, 300);
	
		  input.addEventListener('input', debouncedSearch);
		});
		function showLoadingIndicator(input) {
			// Create a loading indicator element
			const loadingIndicator = document.createElement('div');
			loadingIndicator.className = 'search-loading-indicator';
			loadingIndicator.style.cssText = `
			  position: absolute;
			  right: 10px;
			  top: 50%;
			  transform: translateY(-50%);
			  width: 20px;
			  height: 20px;
			  background-image: url('//www.myoddballs.com/cdn/shop/t/1104/assets/loading.gif?v=447868');
			  background-size: contain;
			  background-repeat: no-repeat;
			`;
		
			// Add the loading indicator to the input's parent container
			input.parentElement.style.position = 'relative';
			input.parentElement.appendChild(loadingIndicator);
		  }
		  function hideLoadingIndicator() {
			const loadingIndicator = document.querySelector('.search-loading-indicator');
			if (loadingIndicator) {
			  loadingIndicator.remove();
			}
		  }
		function performSearch(query) {
		  nostojs(api => {
			api.search({
			  query: query,
			  products: {
        fields: ["name", "price", "listPrice", "imageUrl", "url", "available", "tags1", "categories", "alternateImageUrls", "skus.id", "skus.name", "skus.availability", "skus.customFields.key", "skus.customFields.value", "customFields.key","customFields.value"],
        size: 4,
				facets: ['*']
			  },
			  keywords: {
				fields: ["keyword"],
				size: 5
			  }
			}, {
			  track: 'serp'
			}).then(data => {

                  globRedirect = data.redirect;
                     klaviyo.track("Searched Site",{
                       "SearchTerm": query,
                       "SearchTerm (autocorrected)": query,
                       "ReturnedResults": data.products.total
                     });
			  updateSearchResults(data, query);
              hideLoadingIndicator();
              finaliseSearchCards(data.products.hits, document.getElementById('search-rsults'));
			}).catch(error => {
			  console.error('Error fetching search results:', error);
              			  hideLoadingIndicator();
			});
		  });
		}


	
		function updateSearchResults(data, query) {
		  // Update search term and count
		  const searchTermElements = document.querySelectorAll('.desktop-search-term');
		  const searchCountElements = document.querySelectorAll('.desktop-search-count');
          const seeAllResults = document.getElementById("see-all-results");
          seeAllResults.setAttribute("href", (countryUrl + "/search?q=" + query).replace("//","/"));
		  
		  searchTermElements.forEach(el => el.textContent = `"${query}"`);
		  searchCountElements.forEach(el => el.textContent = data.products.total);
	
		  // Update product results
		  const searchResultsContainer = document.getElementById('search-rsults');
		  if (searchResultsContainer) {
			searchResultsContainer.innerHTML = ''; // Clear existing results
			buildGridItem(data.products.hits, searchResultsContainer);
		  }
	
		  // Update keyword suggestions
		  const keywordSuggestionsContainer = document.getElementById('desktop-nosto-keywords');
		  if (keywordSuggestionsContainer) {
			keywordSuggestionsContainer.innerHTML = '';
			data.keywords.hits.forEach(keyword => {
			  const suggestionElement = document.createElement('div');
			  suggestionElement.className = "text-xs nosto-autocomplete flex";
			  suggestionElement.setAttribute("data-keyword", keyword.keyword);
			  suggestionElement.innerHTML = `
				<b class="mr-1">${query}</b>
				<span class="whitespace-nowrap">${keyword.keyword.replace(query, "")}</span>
			  `;
			  keywordSuggestionsContainer.appendChild(suggestionElement);
			});
		  }
	
		  // Show search results and hide suggestions
		  document.querySelector('.search-suggestions')?.classList.add('hidden');
		  document.querySelector('.search-result')?.classList.remove('hidden');
		}
	
		function showSearchSuggestions() {
		  // Show search suggestions and hide results
		  document.querySelector('.search-suggestions')?.classList.remove('hidden');
		  document.querySelector('.search-result')?.classList.add('hidden');
	
		  // Load default suggestions
		  loadDefaultSuggestions();
		}
        document.addEventListener('click', function(event) {
          if (event.target.closest('.js-show-search-recommendations')) {
              loadDefaultSuggestions();
          }
        }); 
		function loadDefaultSuggestions() {
      loadDefaultProductSuggestions();
      return;
		  const defaultSuggestions = ["Holiday Shop",  "mens boxers", "socks", "bamboo boxers", "womens boxers", "Subscriptions", "Dad & Lad", "Fathers Day", "England FA"];
		  const suggestionsContainer = document.getElementById('pre-search-text-suggestions');
		  if (suggestionsContainer) {
			suggestionsContainer.innerHTML = '';
			defaultSuggestions.forEach(suggestion => {
			  const p = document.createElement('a');
			  p.className = "typography typography--body-md mb-1 capitalize cursor-pointer";
			  p.textContent = suggestion;
              p.setAttribute("href", (countryUrl + "/search?q=" + suggestion).replace("//","/"));
			  suggestionsContainer.appendChild(p);
			});
		  }
	
		  // Load default product suggestions
		}
	
async function loadDefaultProductSuggestions() {
  var searchInput = document.querySelector(".search-collapse-input");
  //searchInput.focus();

  nostojs(async api => {
    try {
      const data = await api.search({
        products: {
          fields: [
            "name", "price", "listPrice", "imageUrl", "url", "available",
            "tags1", "categories", "alternateImageUrls",
            "skus.id", "skus.name", "skus.availability",
            "skus.customFields.key", "skus.customFields.value",
            "customFields.key", "customFields.value"
          ],
          size: 8,
          categoryId: "269146980413",
          facets: ['*']
        }
      });

      const productSuggestionsContainer = document.getElementById('pre-search-product-suggestions');

      if (productSuggestionsContainer) {
        productSuggestionsContainer.innerHTML = '';
        buildGridItem(data.products.hits, productSuggestionsContainer);
        await finaliseSearchCards(data.products.hits, productSuggestionsContainer);
      }
    } catch (error) {
      console.error('Error fetching default product suggestions:', error);
    }
  });
}
	
		function buildGridItem(products, target) {
		  try {
			// Clear existing content
			if (target) {
			  target.innerHTML = '';
			} else {
			  console.warn('Target element not found');
			  return;
			}
	
			// Check if products is an array and not empty
			if (!Array.isArray(products) || products.length === 0) {
			  console.warn('No products to display');
			  return;
			}
	
			products.forEach((product, index) => {
        if(document.querySelectorAll("#pre-search-product-suggestions .product-card").length > 3 && products.length > 4){
          return
        }
            const prodCard = generateProductHtml({product,index, searchPage: true})
            if(prodCard){
                target.append(prodCard)
            }
			});
      prodsAddedFlag = true;
		  } catch (error) {
			console.error('Error in buildGridItem:', error);
			// Display a user-friendly error message
			if (target) {
			  const errorMessage = document.createElement('div');
			  errorMessage.textContent = 'Sorry, we encountered an error while loading the products. Please try again later.';
			  errorMessage.className = 'text-red-500 text-center py-4';
			  target.appendChild(errorMessage);
			}
		  }
		}

      
		function buildImageSlider(swiperWrapper, alternateImages, title) {
		  // Check if the slider has already been built
		  if (swiperWrapper.children.length > 1) {
			return; // Slider already built, exit the function
		  }
	
		  // Add alternate images
		  alternateImages.forEach(altImageUrl => {
			const altSlide = document.createElement('div');
			altSlide.className = 'swiper-slide';
			const altImage = document.createElement('img');
			altImage.className = 'w-full';
			altImage.src = modifyUrlWithResolutions(altImageUrl);
			altImage.loading = 'lazy';
			altImage.alt = title;
			altImage.width = '500';
			altImage.height = '500';
			altSlide.appendChild(altImage);
			swiperWrapper.appendChild(altSlide);
		  });
	
		  // Initialize Swiper
		  new Swiper(swiperWrapper.parentElement, {
			// Swiper options
			loop: true,
			navigation: {
			  nextEl: '.btn-next-pro',
			  prevEl: '.btn-prev-pro',
			},
		  });
		}
	  }

// Same as the collection file's version, but looks the card up inside `root`
// so a product that's also in the collection grid doesn't get the wrong card.
async function updateNonUKPrices(productId, root = document) {
    try {
        const card = root.querySelector(`[data-product-id="${productId}"]`);
        if (!card) {
            debug.error(`Could not find card for product ID: ${productId}`);
            return;
        }

        const prodInfo = card.querySelector('.prod-info');
        if (!prodInfo) return;

        const product = JSON.parse(prodInfo.value);

        const productHandle = getShopifyProductHandle(product.url);

        if (!productHandle) {
            return;
        }

        const url = `/products/${productHandle}.js?country=${countryIso}`;

        const response = await fetch(url);

        const shopifyProduct = await response.json();

        // Verify we have the correct product by comparing handles
        const shopifyHandle = shopifyProduct.handle;
        debug.log('[updateNonUKPrices] Comparing handles:', {
            shopifyHandle,
            productHandle
        });

        if (shopifyHandle !== productHandle) {
            return;
        }

        if (is_sale) {
            const saleTag = product.tags1.find((tag) => {
                return tag.includes("lw-")
            })
            let saleAmount = Number(saleTag?.split("-").pop()) || 0;

            shopifyProduct.price = shopifyProduct.price * (1 - (saleAmount / 100));
        }

        // Update price
        const priceElement = card.querySelector('.product-card__details__price');
        if (priceElement) {
            priceElement.setAttribute("price-updated", "true");

            let price = shopifyProduct.price;
            let comparePrice = shopifyProduct.compare_at_price;

            if (price % 100 !== 0) {
                price = parseFloat(price / 100).toFixed(2);
            } else {
                price = (price / 100);
            }

            const normalPrice = GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, price)

            let listPriceElement = '';
            if (comparePrice && comparePrice > shopifyProduct.price) {
                if (comparePrice % 100 !== 0) {
                    comparePrice = parseFloat(comparePrice / 100).toFixed(2);
                } else {
                    comparePrice = (comparePrice / 100);
                }
                listPriceElement = `<del nick class="ml-1 text-gray-400">${GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, comparePrice)}</del>`;
            } else {
                listPriceElement = `<del nick class="ml-1 text-gray-400 hidden">${GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, price)}</del>`;
            }

            priceElement.innerHTML = `${normalPrice}${listPriceElement}`;
        }

        // Update title and product type
        const titleElement = card.querySelector('.product-card__details__title');
        const categoryElement = card.querySelector('.product-card__details__color');

        if (titleElement) {
            const titleLogicInput = {
                name: shopifyProduct.title,
                tags1: shopifyProduct.tags,
                compare_at_price: shopifyProduct.compare_at_price,
                price: shopifyProduct.price
            };

            const titleInfo = titleLogic(titleLogicInput);
            titleElement.textContent = titleInfo.cleanTitle;

            if (categoryElement && titleInfo.subTitle) {
                categoryElement.textContent = titleInfo.subTitle;
            }
        }

        // Update the stored product info (labels are generated from this)
        const updatedProduct = {
            ...product,
            price: shopifyProduct.price / 100,
            listPrice: shopifyProduct.compare_at_price ? shopifyProduct.compare_at_price / 100 : shopifyProduct.price / 100,
            name: shopifyProduct.title,
            tags1: shopifyProduct.tags
        };
        prodInfo.value = JSON.stringify(updatedProduct);

        debug.log('Successfully updated product:', shopifyHandle);

    } catch (error) {
        debug.error('Error updating product info:', error);
        debug.error('Error stack:', error.stack);
    }
}
		
	
	/**
	 * Creates a debounced version of a function.
	 * 
	 * @param {Function} func - The function to debounce.
	 * @param {number} wait - The number of milliseconds to delay.
	 * @param {boolean} [immediate=false] - Whether to call the function immediately on the leading edge.
	 * @return {Function} The debounced function.
	 */
	function debounce(func, wait, immediate = false) {
		// Validate input parameters
		if (typeof func !== 'function') {
			console.error('debounce: First argument must be a function');
			return () => {}; // Return a no-op function
		}
		if (typeof wait !== 'number' || wait < 0) {
			console.warn('debounce: Invalid wait time, defaulting to 0');
			wait = 0;
		}

		let timeout;

		return function executedFunction(...args) {
			// Store the context for the function to be executed
			const context = this;

			// The function to be executed after the debounce time has elapsed
			const later = function() {
				timeout = null;
				if (!immediate) {
					try {
						func.apply(context, args);
					} catch (error) {
						console.error('Error in debounced function:', error);
					}
				}
			};

			// Determine whether to execute the function on the leading edge
			const callNow = immediate && !timeout;

			// Clear the previous timeout (if any)
			clearTimeout(timeout);

			// Set a new timeout
			timeout = setTimeout(later, wait);

			// If callNow is true, execute the function immediately
			if (callNow) {
				try {
					func.apply(context, args);
				} catch (error) {
					console.error('Error in immediate debounced function call:', error);
				}
			}
		};
	}
		
	/**
	 * Modifies a given URL to create a srcset string with multiple resolutions.
	 * @param {string} url - The original image URL.
	 * @returns {string} A srcset string with multiple resolutions, or the original URL if an error occurs.
	 */
	function modifyUrlWithResolutions(url) {
		try {
			// Array of desired image resolutions
			var resolutions = [360, 420, 480, 640, 840, 1080, 1280, 1540, 1860, 1950];
			
			// Split the URL into filename and extension
			var parts = url.split('.');
			if (parts.length < 2) {
				throw new Error('Invalid URL format');
			}
			
			var fileName = parts.slice(0, -1).join('.'); 
			var fileExtension = parts[parts.length - 1];
			
			// Array to store modified URLs
			var modifiedUrls = [];
		
			// Generate modified URLs for each resolution
			for (var i = 0; i < resolutions.length; i++) {
				var resolution = resolutions[i];
				var modifiedUrl = `${fileName}_${resolution}x.${fileExtension} ${resolution}w`;
				modifiedUrls.push(modifiedUrl);
			}
		
			// Join the modified URLs into a single string
			var result = modifiedUrls.join(',');
		
			// Return the resulting srcset string
			return result;
		} catch (error) {
			console.warn('Error in modifyUrlWithResolutions:', error.message);
			// Return the original URL if an error occurs
			return url;
		}
	}

// Ported from the collection file: last path segment, query string stripped.
function getShopifyProductHandle(url) {
    if (!url) {
        return null;
    }

    try {
        const urlWithoutParams = url.split('?')[0];
        const segments = urlWithoutParams.split('/');
        return segments[segments.length - 1];
    } catch (error) {
        return null;
    }
}

// Ported from the collection file (empty subTitle by default, so non-UK
// cards no longer get "no" written into the subtitle).
function titleLogic(product) {
    try {
        if (!product) {
            debug.log('titleLogic: Product parameter is undefined or null');
            return {
                cleanTitle: '',
                subTitle: '',
                onSale: false
            };
        }

        if (!product.name) {
            debug.log('titleLogic: Product name is undefined or null');
            return {
                cleanTitle: '',
                subTitle: '',
                onSale: false
            };
        }

        let title = product.name;
        let cleanTitle = title;
        let subTitle = '';
        let onSale = false;

        try {
            onSale = Boolean(product.compare_at_price > product.price);
        } catch (priceError) {
            debug.log('titleLogic: Error comparing prices:', priceError);
            onSale = false;
        }

        try {
            if (title.toLowerCase().includes("pre-paid")) {
                try {
                    let tags = Array.isArray(product.tags1) ? product.tags1 : [];

                    if (tags.includes('subscription_classic')) {
                        subTitle = ' Plain Subscription';
                    } else if (tags.includes('subscription_adventurous')) {
                        subTitle = ' Patterned Subscription';
                    }

                    if (title.includes('06 Month Pre-Paid: ')) {
                        cleanTitle = subTitle.replace('', '6 month pre-paid ');
                    } else if (title.includes('12 Month Pre-Paid: ')) {
                        cleanTitle = subTitle.replace('', '12 month pre-paid ');
                    }
                } catch (prePaidError) {
                    debug.log('titleLogic: Error processing pre-paid subscription:', prePaidError);
                }
            } else {
                try {
                    if (cleanTitle && cleanTitle.includes('-')) {
                        let cleanTitleArr = cleanTitle.split(' - ');
                        let cleanTitleFirst = cleanTitleArr[0] + ' - ';
                        subTitle = cleanTitle.replace(cleanTitleFirst, '');
                        cleanTitle = cleanTitleFirst.replace(' - ', '');
                    }
                } catch (regularProductError) {
                    debug.log('titleLogic: Error processing regular product:', regularProductError);
                }
            }
        } catch (mainLogicError) {
            debug.log('titleLogic: Error in main product type logic:', mainLogicError);
        }

        return {
            cleanTitle: cleanTitle || '',
            subTitle: subTitle || '',
            onSale: Boolean(onSale)
        };

    } catch (globalError) {
        console.error('titleLogic: Critical error in title processing:', globalError);
        return {
            cleanTitle: product?.name || '',
            subTitle: '',
            onSale: false
        };
    }
}


const populateFlashSaleList = async (flashSaleWrapper, product, wrapper) => {
    const priceDiv = wrapper.querySelector(".product-card__details__price");
    try{
        
        flashSaleWrapper.className = "animate-mt flash-sale-collection-wrapper"
        let url = `${product.url}?view=get-flash-sale-list`
        const metaObject = await fetch(url);
        const a = await metaObject.text();
        const metaObjectValue = JSON.parse(a); 
        let saleFound = false
        
        metaObjectValue.forEach((sale)=>{
            if(saleFound) return;
            const { sale_number, remaining_sale, sale_type, sale_value, background_colors } = sale;
            const label  = wrapper.closest(".product-card").querySelector(".flash-sale-label");
            const backgroundColor = background_colors? `linear-gradient(to right, ${background_colors[0]} 0%, ${background_colors[1]} 33%, ${background_colors[2]} 66%, ${background_colors[3]} 100%)` : "#f00"
            if(label){
                label.style.border = "2px solid transparent";
                label.style.background = `
                    linear-gradient(#fff, #fff) padding-box,${backgroundColor}`
            }
            const endDate = new Date(sale.end_date);
            const timeToEnd = endDate - Date.now();
            const startDate = new Date(sale.start_date)
            let timeToStart = startDate - Date.now(); 
            if (timeToEnd <= 0 || remaining_sale < 1 || timeToStart > 0 ) {
                return
            }
            saleFound = true

            const timerWrapper = document.createElement("div");
            timerWrapper.className="timer-wrapper"
            const timerSvg = `<svg style="height:12px; color:${background_colors[0]}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6C12.5523 6 13 6.44772 13 7V10.9296C13 11.2099 13.001 11.3523 13.0105 11.4539L13.011 11.459L13.0149 11.4622C13.0942 11.5264 13.2121 11.6062 13.4453 11.7617L15.5547 13.1679C16.0142 13.4743 16.1384 14.0952 15.8321 14.5547C15.5257 15.0142 14.9048 15.1384 14.4453 14.8321L12.3359 13.4258C12.3267 13.4197 12.3176 13.4136 12.3084 13.4075C12.1143 13.2781 11.9165 13.1463 11.7558 13.0161C11.5714 12.8667 11.3804 12.6771 11.2367 12.4085C11.0929 12.14 11.0411 11.8758 11.0191 11.6396C10.9999 11.4336 11 11.1959 11 10.9627V7C11 6.44772 11.4477 6 12 6Z" fill="black"/>
</svg>`
    timerWrapper.innerHTML += timerSvg
    
    const timerDiv = document.createElement("div");
    timerDiv.className="flash-sale-timer"
    timerDiv.style.background = background_colors[0];
    timerDiv.style.webkitBackgroundClip = "text";
    timerDiv.style.backgroundClip = "text";
    timerDiv.style.webkitTextFillColor = "transparent";
    const separator = document.createElement("div");
    separator.innerHTML = "|";
    separator.className = "flash-sale-seperator"
    timerWrapper.append(timerDiv);
    
    flashSaleWrapper.append(timerWrapper, separator);
    
    
    const daysEle = document.createElement("div");
    daysEle.className = "timer-unit timer-days"
    const daysSep = document.createElement("div");
    const hoursSep = document.createElement("div");
    const minutesSep = document.createElement("div");
    
    const hoursEle = document.createElement("div");
    hoursEle.className = "timer-unit timer-hours"
    const minutesEle = document.createElement("div");
    minutesEle.className = "timer-unit timer-minutes"
    const secondsEle = document.createElement("div");
    secondsEle.className = "timer-unit timer-seconds"
    
    daysSep.innerHTML = ":";
    hoursSep.innerHTML = ":";
    minutesSep.innerHTML = ":";
    
    timerDiv.append(daysEle,daysSep,hoursEle,hoursSep,minutesEle,minutesSep,secondsEle);
    
    
    const totalSeconds = Math.floor(timeToEnd / 1000);
    
    const days = Math.floor(totalSeconds / (60 * 60 * 24));
    const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const seconds = totalSeconds % 60;
    const pad = (num) => String(num).padStart(2, "0");
    
    
    daysEle.innerHTML = pad(days);
    hoursEle.innerHTML = pad(hours);
    minutesEle.innerHTML = pad(minutes);
    secondsEle.innerHTML = pad(seconds);
    
    
    const timerInterval = setInterval(()=>{
        const timeToEnd = endDate - Date.now();
        
        if (timeToEnd <= 0) {
            flashSaleWrapper.remove();
            clearInterval(timerInterval);
            return
        }
        
        const totalSeconds = Math.floor(timeToEnd / 1000);
        
        const days = Math.floor(totalSeconds / (60 * 60 * 24));
        const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
        const seconds = totalSeconds % 60;
        
        
        daysEle.innerHTML = pad(days);
        hoursEle.innerHTML = pad(hours);
        minutesEle.innerHTML = pad(minutes);
        secondsEle.innerHTML = pad(seconds);
    }, 1000)
    
    const complete = 100 - Math.round(((sale_number - remaining_sale)/sale_number)*100);
    let saleProgress = document.createElement("div");
    saleProgress.className = "sale-progress-wrapper";
    const saleProgressBarContainer = document.createElement("div");
    saleProgressBarContainer.className = "sale-progress-bar-container"
    const saleProgressText = document.createElement("div");
    saleProgressText.innerHTML = `${complete}% remaining`
    const saleProgressBar = document.createElement("div");
    saleProgressBar.className  = "sale-progress-bar";
    saleProgressBar.style.background = backgroundColor;
    saleProgressBarContainer.append(saleProgressBar);
    saleProgressBar.style.width = `${complete}%`;
    saleProgress.append(saleProgressText, saleProgressBarContainer)
    flashSaleWrapper.append(saleProgress);
    flashSaleWrapper.classList.remove("animate-mt")
    
    let newPrice = sale_type == "percent" ? product.listPrice * (1-sale_value/100) : product.listPrice - sale_value;
    if(priceDiv){
        let listPrice = product.listPrice;
        if (listPrice % 1 !== 0) {
            listPrice = parseFloat(listPrice).toFixed(2);
        }
        if (newPrice % 1 !== 0) {
            newPrice = parseFloat(newPrice).toFixed(2);
        }
        priceDiv.innerHTML =currencySymbol + newPrice + `<del class="ml-1 text-gray-400">${currencySymbol}${listPrice}</del>`
        priceDiv.classList.remove("animate-mt")
    }
})

if(!saleFound){
    wrapper.closest(".product-card").classList.remove("flash-sale-product")
        wrapper.closest(".product-card").querySelector(".label-loc").remove();
        flashSaleWrapper.remove();
        priceDiv.classList.remove("animate-mt")
}
    }catch(error){
        console.error("error:" + error.message);
        console.error("removing flash sale")
        wrapper.closest(".product-card").classList.remove("flash-sale-product")
        flashSaleWrapper.remove();
        priceDiv.classList.remove("animate-mt")
        return
    }
}


const populateFlashSale = async (flashSaleWrapper, product, wrapper) => {
    const priceDiv = wrapper.querySelector(".product-card__details__price");
        try{

        flashSaleWrapper.className = "animate-mt flash-sale-collection-wrapper"
        let url = `${product.url}?view=get-flash-sale`
        const metaObject = await fetch(url);
        const a = await metaObject.text();
        const metaObjectValue = JSON.parse(a); 
        const timerWrapper = document.createElement("div");
        timerWrapper.className="timer-wrapper"
        const timerSvg = `<svg style="height:12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z" fill="black"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6C12.5523 6 13 6.44772 13 7V10.9296C13 11.2099 13.001 11.3523 13.0105 11.4539L13.011 11.459L13.0149 11.4622C13.0942 11.5264 13.2121 11.6062 13.4453 11.7617L15.5547 13.1679C16.0142 13.4743 16.1384 14.0952 15.8321 14.5547C15.5257 15.0142 14.9048 15.1384 14.4453 14.8321L12.3359 13.4258C12.3267 13.4197 12.3176 13.4136 12.3084 13.4075C12.1143 13.2781 11.9165 13.1463 11.7558 13.0161C11.5714 12.8667 11.3804 12.6771 11.2367 12.4085C11.0929 12.14 11.0411 11.8758 11.0191 11.6396C10.9999 11.4336 11 11.1959 11 10.9627V7C11 6.44772 11.4477 6 12 6Z" fill="black"/>
</svg>`
    timerWrapper.innerHTML += timerSvg
    
    const timerDiv = document.createElement("div");
    timerDiv.className="flash-sale-timer"
    const separator = document.createElement("div");
    separator.innerHTML = "|";
    separator.className = "flash-sale-seperator"
    timerWrapper.append(timerDiv);
    
    flashSaleWrapper.append(timerWrapper, separator);
    
    
    const daysEle = document.createElement("div");
    daysEle.className = "timer-unit timer-days"
    const daysSep = document.createElement("div");
    const hoursSep = document.createElement("div");
    const minutesSep = document.createElement("div");
    
    const hoursEle = document.createElement("div");
    hoursEle.className = "timer-unit timer-hours"
    const minutesEle = document.createElement("div");
    minutesEle.className = "timer-unit timer-minutes"
    const secondsEle = document.createElement("div");
    secondsEle.className = "timer-unit timer-seconds"
    
    daysSep.innerHTML = ":";
    hoursSep.innerHTML = ":";
    minutesSep.innerHTML = ":";
    
    timerDiv.append(daysEle,daysSep,hoursEle,hoursSep,minutesEle,minutesSep,secondsEle);
    
    const endDate = new Date(metaObjectValue.end_date);
    const timeToEnd = endDate - Date.now();
    
    
    const { sale_number, remaining_sale, sale_type, sale_value } = metaObjectValue;
    if (timeToEnd <= 0 || remaining_sale < 1) {
        wrapper.closest(".product-card").classList.remove("flash-sale-product")
        wrapper.closest(".product-card").querySelector(".label-loc").remove();
        flashSaleWrapper.remove();
        priceDiv.classList.remove("animate-mt")
        return
    }
    
    const totalSeconds = Math.floor(timeToEnd / 1000);
    
    const days = Math.floor(totalSeconds / (60 * 60 * 24));
    const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const seconds = totalSeconds % 60;
    const pad = (num) => String(num).padStart(2, "0");
    
    
    daysEle.innerHTML = pad(days);
    hoursEle.innerHTML = pad(hours);
    minutesEle.innerHTML = pad(minutes);
    secondsEle.innerHTML = pad(seconds);
    
    
    const timerInterval = setInterval(()=>{
                
        const endDate = new Date(metaObjectValue.end_date);
        const timeToEnd = endDate - Date.now();
        
        if (timeToEnd <= 0) {
            flashSaleWrapper.remove();
            clearInterval(timerInterval);
            return
        }
        
        const totalSeconds = Math.floor(timeToEnd / 1000);
        
        const days = Math.floor(totalSeconds / (60 * 60 * 24));
        const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
        const seconds = totalSeconds % 60;
        
        
        daysEle.innerHTML = pad(days);
        hoursEle.innerHTML = pad(hours);
        minutesEle.innerHTML = pad(minutes);
        secondsEle.innerHTML = pad(seconds);
    }, 1000)

    const complete = Math.round(((sale_number - remaining_sale)/sale_number)*100);
    let saleProgress = document.createElement("div");
    saleProgress.className = "sale-progress-wrapper";
    const saleProgressBarContainer = document.createElement("div");
    saleProgressBarContainer.className = "sale-progress-bar-container"
    const saleProgressText = document.createElement("div");
    saleProgressText.innerHTML = `${complete}% claimed`
    const saleProgressBar = document.createElement("div");
    saleProgressBar.className  = "sale-progress-bar";
    saleProgressBarContainer.append(saleProgressBar);
    saleProgressBar.style.width = `${complete}%`;
    saleProgress.append(saleProgressText, saleProgressBarContainer)
    flashSaleWrapper.append(saleProgress);
    flashSaleWrapper.classList.remove("animate-mt")
    
    let newPrice = sale_type == "percent" ? product.listPrice * (1-sale_value/100) : product.listPrice - sale_value;
    if(priceDiv){
        let listPrice = product.listPrice;
        if (listPrice % 1 !== 0) {
            listPrice = parseFloat(listPrice).toFixed(2);
        }
        if (newPrice % 1 !== 0) {
            newPrice = parseFloat(newPrice).toFixed(2);
        }
        priceDiv.innerHTML =GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, newPrice) + `<del class="ml-1 text-gray-400">${GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, listPrice)}</del>`
        priceDiv.classList.remove("animate-mt")
        }
    }catch(error){
        console.error("error:" + error.message);
        console.error("removing flash sale")
        wrapper.closest(".product-card").classList.remove("flash-sale-product")
        flashSaleWrapper.remove();
        priceDiv.classList.remove("animate-mt")
        return
    }
}
const createFlashSaleProdList = (product,  wrapper) => {
    const flashSaleWrapper = document.createElement("div");

    populateFlashSaleList(flashSaleWrapper, product, wrapper)
    return(flashSaleWrapper)
}
const createFlashSaleProd = (product,  wrapper) => {
    const flashSaleWrapper = document.createElement("div");

    populateFlashSale(flashSaleWrapper, product, wrapper)
    return(flashSaleWrapper)
}

});